import { z } from '@/utils/zod'

import { SpaPresenterSchema } from './SpaPresenter'
import { StaticPresenterSchema } from './StaticPresenter'
import { TestPresenterSchema } from './TestPresenter'

export const PresenterSchema = z.discriminatedUnion('type', [
    SpaPresenterSchema,
    StaticPresenterSchema,
    TestPresenterSchema,
])

export type Presenter = z.infer<typeof PresenterSchema>

export type PresenterType = Presenter['type']
